import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss']
})
export class ModalComponent implements OnInit {

  @Input() state!: boolean;
  @Input() size!: { height: string, width: string }
  @Input() template!: { header?: any, body: any, footer?: any }

  ngOnInit() {
    this.state = false;
  }

}
